import { useEffect, useState } from 'react';

import type { FormReadyMessage, SetFormScriptMessage } from '@gn-audio/jss-core';
import { FormMessageType } from '@gn-audio/jss-core';

import { postFormMessage } from './postFormMessage';

export const useFormScript = () => {
  const [formScript, setFormScript] = useState<string>();

  useEffect(() => {
    const handleSetFormScriptFromParent = (event: MessageEvent<SetFormScriptMessage>) => {
      const isFromParentWindow = event.source === window.parent;
      const isSetFormScriptMessage = event.data?.type === FormMessageType.SetFormScript;

      if (!isFromParentWindow || !isSetFormScriptMessage) return;

      setFormScript(event.data.formScript);
    };

    const notifyParentFormIsReady = () => {
      const formReadyMessage: FormReadyMessage = { type: FormMessageType.FormReady };
      postFormMessage<FormReadyMessage>(formReadyMessage);
    };

    window.addEventListener('message', handleSetFormScriptFromParent);
    notifyParentFormIsReady();

    return () => window.removeEventListener('message', handleSetFormScriptFromParent);
  }, []);

  return formScript;
};
